import './App.css';
import SeoHead from './components/SeoHead';
import SeoJsonLd from './components/SeoJsonLd';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import DeploymentModes from './components/DeploymentModes';
import IndustrySolutions from './components/IndustrySolutions';
import Philosophy from './components/Philosophy';
import Audiences from './components/Audiences';
import Mission from './components/Mission';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AnalyticsConsent from './components/AnalyticsConsent';
import { Analytics } from '@vercel/analytics/react';

function App() {
  return (
    <div className="ca-app">
      <Analytics />
      <SeoHead />
      <SeoJsonLd />
      <AnalyticsConsent />
      <Header />
      <main>
        <Hero />
        <Services />
        <DeploymentModes />
        <IndustrySolutions />
        <Philosophy />
        <Audiences />
        <Mission />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
